import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import Tilty from 'react-tilty';
import { useTranslation } from 'react-i18next';
import AboutTwoGeral from '../component/about/AboutTwo_Geral'
import { Link } from 'react-router-dom';
import ShapeBubble from '../component/shapes/ShapeBubble';

const ServiceDetails = () => {
    const { t } = useTranslation();

    return (
        <>
            <SEO title={t('Electricité')} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne
                    title={t('Electricité')}
                    paragraph="descricao de electricite"
                    styleClass=""
                    mainThumb="/images/banner/eletricidade3.jpg"
                />

                <div className="section section-padding bg-color-light pb--70">
                    <SectionTitle
                        subtitle="outro subtitulo"
                        title="outro titulo"
                        description="descricao"
                        textAlignment=""
                        textColor="mb--90"
                    />
                    <div className="container">

                        <div className='process-work'>

                            <Tilty perspective={2000}>
                                <Link to='/service-Courant_Fort'>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/Eletricite/courant_fort_1220x920.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Link>
                            </Tilty>
                            <div className="content">
                                <Link to='/service-Courant_Fort'>
                                    <p className="title h3">{t('courantfort')}</p>
                                    <p>texto</p>
                                </Link>
                            </div>

                        </div>

                        <div className='process-work content-reverse'>
                            <Tilty perspective={2000}>
                                <Link to='/service-Courant_Faible'>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/Eletricite/courant_faible_1220x920.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Link>
                            </Tilty>
                            <div className="content">
                                <Link to='/service-Courant_Faible'>
                                    <p className="title h3">{t('courantfaible')}</p>
                                    <p>texto</p>
                                </Link>
                            </div>
                        </div>

                        <div className='process-work'>
                            <Tilty perspective={2000}>
                                <Link to='/service-Audiovisuel'>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/Eletricite/audiovisuel_1220x920.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Link>
                            </Tilty>
                            <div className="content">
                                <Link to='/service-Audiovisuel'>
                                    <p className="title h3">{t('Audiovisuel')}</p>
                                    <p>texto</p>
                                </Link>
                            </div>
                        </div>

                        <div className='process-work content-reverse'>
                            <Tilty perspective={2000}>
                                <Link to='/service-Securite'>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/Eletricite/securite_1220x920.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Link>
                            </Tilty>
                            <div className="content">
                                <Link to='/service-Securite'>
                                    <p className="title h3">{t('Securite')}</p>
                                    <p>texto</p>
                                </Link>
                            </div>
                        </div>

                    </div>
                    <ul className="shape-group-17 list-unstyled">
                        <ShapeBubble />
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                        <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                    </ul>
                </div>

                <AboutTwoGeral />
                {/* <CtaLayoutOne /> */}
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default ServiceDetails;